import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { capitalizeString, handleTextBoxChange } from "@/actions/common";
import {
    checkIsNull,
    createS3Folder,
    replaceComma,
    thousandSeperatedValue,
} from "@/helpers/common";
import TextBox from "@/components/Common/TextBox";
import {
    removeNegativeInput,
} from "@/helpers/validations";
import CheckBox from "@/components/Common/CheckBox";
import {
    adaAccessCheckBox,
    DEFAULT_INVENTORY_MAP_ZOOM,
    IS_APARTMENT_CONDO,
    IS_ENTIRE_PLACE,
    IS_GUEST_HOUSE,
    IS_PRIVATE_ROOM,
    newConstructionCheckBox,
} from "@/constants/common";
import { removeDecimalZeros } from "@/helpers/v2/common";


export const InventoryGeneralLocationsForm = (props) => {

    const {
        formValues,
        handleFormValues,
        isEditingProperty
    } = props;

    const neighborHood = _.get(formValues, "neighborHood", null)
    const highSchool = _.get(formValues, "highSchool", null)
    const yearBuilt = _.get(formValues, "yearBuilt", null)
    const validationErrors = _.get(formValues, "validationErrors", null)
    const noBedRm = removeDecimalZeros(_.get(formValues, "noBedRm", null))
    const noBathRm = removeDecimalZeros(_.get(formValues, "noBathRm", null))
    const sqFt = removeDecimalZeros(_.get(formValues, "sqFt", null))
    const stories = _.get(formValues, "stories", null)
    const lotSize = _.get(formValues, "lotSize", null)
    const grgeSpots = _.get(formValues, "grgeSpots", null)
    const adaAccess = _.get(formValues, "adaAccess", false)
    const IsNewConstruction = _.get(formValues, "IsNewConstruction", false)
    const propertyType = _.get(formValues, "propertyType", null)
    const propertySubType = _.get(formValues, "propertySubType", null)
    const mapZoom = _.get(formValues, "mapZoom", null)

    const isMapValidLocation = formValues?.isMapValidLocation

    // Initialize component state variables and constants.
    const [yearBuiltError, setYearBuiltError] = useState("");

    const isLotSizeDisable =
        propertyType === IS_ENTIRE_PLACE &&
        (propertySubType === IS_APARTMENT_CONDO ||
            propertySubType === IS_GUEST_HOUSE);
    const isPrivateRoom = propertyType === IS_PRIVATE_ROOM;

    // To set the folder name for map image upload
    useEffect(() => {
        handleFormValues({
            mapZoom: mapZoom || DEFAULT_INVENTORY_MAP_ZOOM,
        });
    }, []);

    // validationErrors state change side effect handling.
    useEffect(() => {
        setYearBuiltError("");
        if (validationErrors && validationErrors.length > 0) {
            validationErrors.map((item) => {
                if (item == "yearBuiltRange") {
                    setYearBuiltError("Enter Valid year");
                }
            });
        }
    }, [validationErrors]);

    // To update the state values
    const updateValuesToState = (key, value) => {
        if (!checkIsNull(value)) {
            handleFormValues({ [key]: value });
        } else {
            handleFormValues({ [key]: "" });
        }
    };

    // bed room change event handler
    const handleBedRoomChange = (e) => {
        let value = removeNegativeInput(handleTextBoxChange(e));
        if (value === "0") {
            value = 1;
        } else if (replaceComma(value) > 100) {
            value = 100;
        }
        updateValuesToState("noBedRm", replaceComma(value));
    };

    // bathroom change event handler
    const handleBathRoomChange = (e) => {
        let value = removeNegativeInput(handleTextBoxChange(e));
        if (value === "0") {
            value = 1;
        } else if (replaceComma(value) > 100) {
            value = 100;
        }
        updateValuesToState("noBathRm", replaceComma(value));
    };

    // square feet chage event handler
    const handleSqFtChange = (e) => {
        let value = removeNegativeInput(handleTextBoxChange(e));
        if (value === "0") {
            value = 1;
        } else if (replaceComma(value) > 10000) {
            value = 10000;
        }
        updateValuesToState("sqFt", replaceComma(value));
    };

    // To handle the stories change
    const handleStoryChange = (e) => {
        const value = removeNegativeInput(handleTextBoxChange(e));
        updateValuesToState("stories", replaceComma(value));
    };

    // lot size chnage handler
    const handleLotSizeChange = (e) => {
        const value = removeNegativeInput(handleTextBoxChange(e));
        updateValuesToState("lotSize", replaceComma(value));
    };

    // garrage spot change handler
    const handleGarrageSpotChange = (e) => {
        const value = removeNegativeInput(handleTextBoxChange(e));
        updateValuesToState("grgeSpots", replaceComma(value));
    };

    // year built change handler
    const handleYearBuitChange = (e) => {
        setYearBuiltError("");
        const value = removeNegativeInput(handleTextBoxChange(e));
        updateValuesToState("yearBuilt", replaceComma(value));
    };

    // neighborhood change handler
    const handleNeighborhoodChange = (e) => {
        const value = capitalizeString(handleTextBoxChange(e));
        updateValuesToState("neighborHood", value);
    };

    // high school change handler
    const handleHighSchoolChange = (e) => {
        const value = capitalizeString(handleTextBoxChange(e));
        updateValuesToState("highSchool", value);
    };

    // ada access and is new construction checkbox change event handler
    const handleCheckBoxClick = (e) => {
        if (e.target.id === adaAccessCheckBox) {
            handleFormValues({ adaAccess: e.target.checked });
        } else {
            handleFormValues({ IsNewConstruction: e.target.checked });
        }
    };


    const disabledFormInputs = !isMapValidLocation && !isEditingProperty;

    return (
        <>
            <div className={`wantad-location-wrap mb-${isMapValidLocation ? 0 : 5}`}>
                <div className="section-control mb-40">
                    <h6 className="mt-5">Basics</h6>
                    {!isPrivateRoom && (
                        <div className="row">
                            <div className="col-md-6">
                                <div className="common-input-wrap mb-2">
                                    <Form.Label>Neighborhood</Form.Label>
                                    <TextBox
                                        type="text"
                                        className="form-control"
                                        disabled={disabledFormInputs}
                                        value={neighborHood}
                                        onChange={(e) => {
                                            handleNeighborhoodChange(e);
                                        }}
                                    />
                                    <div className="error-msg"></div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="common-input-wrap mb-2">
                                    <Form.Label>High School</Form.Label>
                                    <TextBox
                                        type="text"
                                        className="form-control"
                                        disabled={disabledFormInputs}
                                        value={highSchool}
                                        onChange={(e) => {
                                            handleHighSchoolChange(e);
                                        }}
                                    />
                                    <div className="error-msg"></div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="common-input-wrap mb-2">
                                    <Form.Label>Bedrooms</Form.Label>
                                    <TextBox
                                        disabled={disabledFormInputs}
                                        type="text"
                                        className="form-control"
                                        value={thousandSeperatedValue(noBedRm) || ""}
                                        onChange={(e) => {
                                            handleBedRoomChange(e);
                                        }}
                                    />
                                    <div className="error-msg"></div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="common-input-wrap mb-2">
                                    <Form.Label>Bathrooms</Form.Label>
                                    <TextBox
                                        type="text"
                                        className="form-control"
                                        disabled={disabledFormInputs}
                                        value={thousandSeperatedValue(noBathRm) || ""}
                                        onChange={(e) => {
                                            handleBathRoomChange(e);
                                        }}
                                    />
                                    <div className="error-msg"></div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="common-input-wrap mb-2">
                                    <Form.Label>Square footage</Form.Label>
                                    <TextBox
                                        type="text"
                                        className="form-control"
                                        disabled={disabledFormInputs}
                                        value={thousandSeperatedValue(sqFt) || ""}
                                        onChange={(e) => {
                                            handleSqFtChange(e);
                                        }}
                                    />
                                    <div className="error-msg"></div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="common-input-wrap mb-2">
                                    <Form.Label>Stories</Form.Label>

                                    <TextBox
                                        type="text"
                                        className="form-control"
                                        disabled={disabledFormInputs}
                                        value={thousandSeperatedValue(stories) || ""}
                                        onChange={(e) => {
                                            handleStoryChange(e);
                                        }}
                                    />
                                    <div className="error-msg"></div>
                                </div>
                            </div>
                            {!isLotSizeDisable && (
                                <div className="col-md-3">
                                    <div className="common-input-wrap mb-2">
                                        <Form.Label>Lot size (Acres)</Form.Label>

                                        <TextBox
                                            type="text"
                                            className="form-control"
                                            disabled={disabledFormInputs}
                                            value={thousandSeperatedValue(lotSize) || ""}
                                            onChange={(e) => {
                                                handleLotSizeChange(e);
                                            }}
                                        />
                                        <div className="error-msg"></div>
                                    </div>
                                </div>
                            )}

                            <div className="col-md-3">
                                <div className="common-input-wrap mb-2">
                                    <Form.Label>Garage Spots</Form.Label>
                                    <TextBox
                                        type="text"
                                        className="form-control"
                                        disabled={disabledFormInputs}
                                        value={thousandSeperatedValue(grgeSpots) || ""}
                                        onChange={(e) => {
                                            handleGarrageSpotChange(e);
                                        }}
                                    />
                                    <div className="error-msg"></div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="common-input-wrap mb-2">
                                    <Form.Label>Year Built</Form.Label>
                                    <TextBox
                                        type="text"
                                        className="form-control"
                                        disabled={disabledFormInputs}
                                        errorMessage={yearBuiltError}
                                        value={yearBuilt}
                                        onChange={(e) => {
                                            handleYearBuitChange(e);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="row">
                        {propertyType !== IS_PRIVATE_ROOM && (
                            <div className="col-md-4">
                                <div className="field-wrap mt-0 mb-0">
                                    <label
                                        className="form-check-label checkbox-label"
                                        htmlFor={newConstructionCheckBox}
                                    >
                                        <CheckBox
                                            className="form-check-input"
                                            type="checkbox"
                                            disabled={disabledFormInputs}
                                            id={newConstructionCheckBox}
                                            checked={IsNewConstruction}
                                            onChange={(e) => handleCheckBoxClick(e)}
                                        />{" "}
                                        New Construction
                                    </label>
                                </div>
                            </div>
                        )}

                        <div className="col-md-8">
                            <div className="field-wrap mt-0 mb-0">
                                <label
                                    className="form-check-label checkbox-label"
                                    htmlFor={adaAccessCheckBox}
                                >
                                    <CheckBox
                                        className="form-check-input"
                                        type="checkbox"
                                        id={adaAccessCheckBox}
                                        checked={adaAccess}
                                        onChange={(e) => handleCheckBoxClick(e)}
                                        disabled={disabledFormInputs}
                                    />{" "}
                                    ADA Accessible
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
